import React from "react";
import DeleteConfirmation from "components/ui/DeleteConfirmation";
import { useDeleteSchemeMaster } from "http-hooks/schemeMaster/useSchemeMaster";

export default function DeleteSchemeMaster({ id, onClose }) {
  const { mutateAsync, isPending } = useDeleteSchemeMaster();

  const handleDelete = async () => {
    try {
      await mutateAsync(id);
      onClose();
    } catch (error) {
      console.error("Delete failed:", error);
    }
  };

  return (
    <DeleteConfirmation
      title="Delete Scheme"
      description="Are you sure you want to delete this scheme? This scheme will be permanently removed. This action cannot be undone."
      onDelete={handleDelete}
      onClose={onClose}
      isLoading={isPending}
    />
  );
}
